import { useRouter } from "next/compat/router";
import Link from "@components/core/Link";
import classNames from "classnames";

function ProfileLayoutLink({ href, children }) {
  const router = useRouter();
  const isActive = href === router.pathname;

  return (
    <Link
      href={href}
      className="link-dark font-weight-normal"
      noUnderline
    >
      <div className={classNames("profile-layout-link", isActive && "active")}>
        <span>{children}</span>
      </div>
    </Link>
  );
}

export default ProfileLayoutLink;
